import Vue from 'vue'
import App from './App.vue'
import vuescroll from 'vue-scroll';
import router from './router'
// 全量引入 Vant（适配移动端）
import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant);
Vue.use(vuescroll);



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')